export default "/images/vendor/flag-icons/flags/1x1/cm.svg?c5fdb1729d6a61e705cc4fa9f2555638";